
import { Component } from '@angular/core';
import { BooksLocalPage } from '../books-local/books-local';
import { BooksOnlinePage } from '../books-online/books-online';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = BooksLocalPage;
  tab2Root = BooksOnlinePage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts